// extracted by mini-css-extract-plugin
module.exports = {"packsModal":"Modal_packsModal__247W5","form":"Modal_form__rEWWr"};